import { useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 PRO React TS components
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

import FormField from "components/FormField";

import { useParameterByName } from "api/features/parameter/queries";
import { useFormikContext } from "formik";

function UpdateLinkForm({ formData }: any): JSX.Element {
  const { formField, values, errors, touched } = formData;
  const { title, url } = formField;
  const { url: urlV, title: titleV } = values;

  const { setFieldValue } = useFormikContext<any>();

  const { data: titleValue } = useParameterByName("NAVBAR_CUSTOM_LINK_TITLE");
  const { data: urlValue } = useParameterByName("NAVBAR_CUSTOM_LINK_URL");

  // Initialize formik values with the current title and url from context
  useEffect(() => {
    setFieldValue(title.name, titleValue?.value ?? "", false);
    setFieldValue(url.name, urlValue?.value ?? "", false);
  }, [titleValue, urlValue]);

  useEffect(() => {
    console.log(errors, touched);
  }, [errors, touched]);

  return (
    <MDBox bgColor="white" borderRadius="sm" sx={{ boxShadow: 1 }} p={2} my={1}>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <MDTypography variant="h6">{title.label}: </MDTypography>
          <FormField
            type={title.type}
            label={title.label}
            name={title.name}
            value={titleV}
            placeholder={title.placeholder}
            error={errors.title && touched.title}
            success={titleV?.length > 0 && !errors.title}
          />
        </Grid>
        <Grid item xs={12}>
          <MDTypography
            variant="caption"
            color="error"
            fontWeight="regular"
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {errors.title}
          </MDTypography>
        </Grid>
        <Grid item xs={12}>
          <MDTypography variant="h6">{url.label}: </MDTypography>
          <FormField
            type={url.type}
            label={url.label}
            name={url.name}
            value={urlV}
            placeholder={url.placeholder}
            error={errors.url && touched.url}
            success={urlV?.length > 0 && !errors.url}
          />
        </Grid>
        <Grid item xs={12}>
          <MDTypography
            variant="caption"
            color="error"
            fontWeight="regular"
            sx={{ whiteSpace: "pre-wrap" }}
          >
            {errors.url}
          </MDTypography>
        </Grid>
      </Grid>
    </MDBox>
  );
}

export default UpdateLinkForm;
